import { Injectable } from "@angular/core";
import {
  Auth,
  AuthProvider,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  updateEmail,
  updatePassword,
  User
} from "@angular/fire/auth";

@Injectable({ providedIn: "root" })
export class AuthService {
  constructor(private auth: Auth) {}

  signUpUserWithEmailAndPassword(email: string, password: string) {
    return createUserWithEmailAndPassword(this.auth, email, password);
  }

  signInUserWithEmailAndPassword(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  signInWithPopup(provider: AuthProvider) {
    return signInWithPopup(this.auth, provider);
  }

  signInWithGoogle() {
    return this.signInWithPopup(new GoogleAuthProvider());
  }

  signInWithFacebook() {
    return this.signInWithPopup(new FacebookAuthProvider());
  }

  signInWithTwitter() {
    return this.signInWithPopup(new TwitterAuthProvider());
  }

  sendPasswordResetEmail(email: string) {
    return sendPasswordResetEmail(this.auth, email);
  }

  updateEmail(email: string) {
    return updateEmail(this.auth.currentUser || <User>{}, email);
  }

  updatePassword(password: string) {
    return updatePassword(this.auth.currentUser || <User>{}, password);
  }

  signOut() {
    return this.auth.signOut();
  }
}
